import U from "axios";
import * as c from "@sentry/react";
const u = 5, T = 1440 * 60 * 1e3, A = "llm_rate_limit_data";
function h() {
  try {
    const s = localStorage.getItem(A);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
}
function d(s) {
  try {
    localStorage.setItem(A, JSON.stringify(s));
  } catch {
  }
}
function g() {
  const s = Date.now();
  let t = h();
  if (t || (t = {
    count: 0,
    resetTime: s + T
  }, d(t)), s > t.resetTime && (t.count = 0, t.resetTime = s + T, d(t)), t.count >= u) {
    const n = Math.ceil((t.resetTime - s) / 1e3 / 60 / 60);
    throw new Error(`Rate limit exceeded. You have reached the maximum of ${u} requests per 24 hours. Try again in ${n} hours.`);
  }
  return t.count++, d(t), {
    remaining: u - t.count,
    resetTime: t.resetTime
  };
}
const C = (s) => {
  const t = U.create({
    baseURL: "https://staging.minohealth.ai:3002",
    headers: {
      Authorization: `Bearer ${s}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }), n = U.create({
    baseURL: "https://staging.minohealth.ai:3002",
    headers: {
      Authorization: `Bearer ${s}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data"
    }
  });
  function R(e) {
    return (a) => (a.params ||= {}, Object.assign(a.params, e), a);
  }
  function b(e) {
    let a = e?.response?.request?.responseURL;
    return e?.response?.request?.status === 401 && !M(a) && document.dispatchEvent(new CustomEvent(j, {})), Promise.reject(e);
  }
  function E(e) {
    if (e?.response?.status === 429) {
      const a = e.response.data;
      if (a?.rateLimitExceeded) {
        const r = a.resetTime || Date.now() + T;
        d({
          count: u,
          resetTime: r
        });
      }
    }
    return Promise.reject(e);
  }
  const _ = ["/signin", "/google", "/linkedin"];
  function M(e) {
    for (let a of _)
      if (e.endsWith(a)) return !0;
    return !1;
  }
  return t.interceptors.response.use((e) => e, b), t.interceptors.response.use((e) => e, E), n.interceptors.response.use((e) => e, b), n.interceptors.response.use((e) => e, E), t.interceptors.request.use(R({ lng: I })), n.interceptors.request.use(R({ lng: I })), t.interceptors.request.use((e) => (c.addBreadcrumb({
    category: "http",
    type: "http",
    level: "info",
    message: `${e.method?.toUpperCase()} ${e.url} (LLM API)`,
    data: {
      url: e.url,
      method: e.method,
      baseURL: e.baseURL,
      params: e.params
    }
  }), e)), n.interceptors.request.use((e) => (c.addBreadcrumb({
    category: "http",
    type: "http",
    level: "info",
    message: `${e.method?.toUpperCase()} ${e.url} (LLM API - multipart)`,
    data: {
      url: e.url,
      method: e.method,
      baseURL: e.baseURL
    }
  }), e)), t.interceptors.response.use(
    (e) => (c.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${e.config.method?.toUpperCase()} ${e.config.url} (LLM API) - ${e.status}`,
      data: {
        url: e.config.url,
        method: e.config.method,
        status: e.status
      }
    }), e),
    (e) => {
      const a = e.response?.status, r = e.config?.url, o = e.config?.method;
      return c.addBreadcrumb({
        category: "http",
        type: "error",
        level: "error",
        message: `${o?.toUpperCase()} ${r} (LLM API) - ${a || "Network Error"}`,
        data: {
          url: r,
          method: o,
          status: a,
          errorMessage: e.message,
          responseData: e.response?.data
        }
      }), c.captureException(e, {
        tags: {
          api_service: "llm",
          api_endpoint: r,
          http_method: o,
          http_status: a
        },
        contexts: {
          response: {
            status: a,
            data: e.response?.data
          },
          request: {
            url: r,
            method: o,
            params: e.config?.params
          }
        }
      }), Promise.reject(e);
    }
  ), n.interceptors.response.use(
    (e) => (c.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${e.config.method?.toUpperCase()} ${e.config.url} (LLM API - multipart) - ${e.status}`,
      data: {
        url: e.config.url,
        method: e.config.method,
        status: e.status
      }
    }), e),
    (e) => {
      const a = e.response?.status, r = e.config?.url, o = e.config?.method;
      return c.addBreadcrumb({
        category: "http",
        type: "error",
        level: "error",
        message: `${o?.toUpperCase()} ${r} (LLM API - multipart) - ${a || "Network Error"}`,
        data: {
          url: r,
          method: o,
          status: a,
          errorMessage: e.message
        }
      }), c.captureException(e, {
        tags: {
          api_service: "llm",
          api_endpoint: r,
          http_method: o,
          http_status: a,
          content_type: "multipart/form-data"
        }
      }), Promise.reject(e);
    }
  ), {
    /**
     * Get a presigned download URL for a Spaces object.
     * @param {string} url Full Spaces object URL
     * @returns {Promise<string>} Presigned URL
     */
    getPresignedDownloadUrl: async (e) => (await t.get("/objects/presign", { params: { url: e } })).data.url,
    /**
     * Get a presigned upload URL for a Spaces object.
     * @param {string} key Object key within the bucket
     * @param {string} contentType MIME type of the file
     * @returns {Promise<{ uploadUrl: string, objectUrl: string }>}
     */
    getPresignedUploadUrl: async (e, a) => (await t.get("/objects/presign/upload", { params: { key: e, contentType: a } })).data,
    PostLLMInference: (e) => (g(), t.post("/llm/inference", e)),
    /**
     * Perform an LLM inference request with an image using multipart/form-data.
     * The request is subject to the same client-side rate-limit used for text inference.
     *
     * @param {File} imageFile – image blob selected in the browser (png / jpeg / etc.)
     * @param {Object} [chatHistory] – optional chat object { chat: [...] }
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    PostLLMImageInference: (e, a = { chat: [] }) => {
      g();
      const r = new FormData();
      return r.append("image", e), r.append("chatHistory", JSON.stringify(a)), n.post("/llm/inference", r);
    },
    /**
     * Streaming image inference using browser fetch & FormData.
     * Returns a ReadableStreamDefaultReader of UTF-8 chunks.
     *
     * @param {File} imageFile
     * @param {Object} [chatHistory]
     * @returns {Promise<ReadableStreamDefaultReader<Uint8Array>>}
     */
    streamLLMImageInference: async (e, a = { chat: [] }) => {
      try {
        g();
      } catch (i) {
        throw new f(i.message, h()?.resetTime);
      }
      const r = new FormData();
      r.append("image", e), r.append("chatHistory", JSON.stringify(a));
      const o = await fetch(new URL("/llm/inference", "https://staging.minohealth.ai:3002").href, {
        method: "POST",
        body: r
      });
      if (o.status === 429) {
        let i;
        try {
          i = await o.json();
        } catch {
          i = { message: "Rate limit exceeded", resetTime: null };
        }
        throw new f(i.message, i.resetTime);
      }
      if (!o.body) throw new Error("No response body for streaming");
      return o.body.getReader();
    },
    getRateLimitInfo: () => {
      const e = h();
      return e ? Date.now() > e.resetTime ? { remaining: u, resetTime: null } : {
        remaining: Math.max(0, u - e.count),
        resetTime: e.resetTime
      } : { remaining: u, resetTime: null };
    },
    getStudies: (e) => t.get("/pacs/allStudies", {
      params: { page: 1, limit: 10, ...e }
    }),
    getStudy: (e) => t.get("/pacs/study", {
      params: { studyInstanceUid: e }
    }),
    // ── Integration endpoints ─────────────────────────────────
    /**
     * Fetch all integrations for the authenticated user.
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    getIntegrations: () => t.get("/agent/integrations"),
    /**
     * Add a new integration (URL-based or file-based).
     * @param {FormData} formData – must include `ehr_name`; optionally `url`, `files[]`,
     *   `auth_instructions`, `bypass_validation`, `org_id`
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    addIntegration: (e) => n.post("/agent/integrations", e),
    /**
     * Delete an active integration by its ID.
     * @param {string} integrationId
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    deleteIntegration: (e) => t.delete(`/agent/integrations/${e}`),
    /**
     * Toggle integration enabled status.
     * @param {string} id - Integration ID
     * @param {boolean} enabled - Enabled state
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    toggleIntegrationStatus: (e, a) => t.patch(`/agent/integrations/${e}/enable`, { enabled: a }),
    /**
     * Update integration credentials.
     * @param {string} id - Integration ID
     * @param {Object} credentials - Credentials object
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    updateIntegrationCredentials: (e, a) => t.patch(`/agent/integrations/${e}/credentials`, { credentials: a }),
    /**
     * Check integration health.
     * @param {string} id - Integration ID
     * @param {Object} [credentials] - Optional credentials to override stored ones
     * @returns {Promise<import('axios').AxiosResponse<any>>}
     */
    checkIntegrationHealth: (e, a) => t.post(`/agent/integrations/${e}/health-check`, { credentials: a }),
    /**
     * Retry failed integration.
     * @param {string} id - Integration ID
     * @returns {Promise<import('axios').AxiosResponse<{job_id: string}>>}
     */
    retryFailedIntegration: (e) => t.post(`/agent/integrations/${e}/retry`),
    /**
     * Poll a pending integration job via SSE.
     * Returns an AbortController so the caller can cancel.
     *
     * @param {string} jobId
     * @param {{ onProgress?: (text: string) => void, onResult?: (result: object) => void, onError?: (err: Error) => void }} callbacks
     * @returns {AbortController}
     */
    pollIntegrationStatus: (e, { onProgress: a, onResult: r, onError: o } = {}) => {
      const i = new AbortController();
      return (async () => {
        try {
          const l = new URL(`agent/integrations/results/${e}`, "https://staging.minohealth.ai:3002").href, y = await fetch(l, {
            headers: { Authorization: `Bearer ${s}` },
            signal: i.signal
          });
          if ((y.headers.get("content-type") || "").includes("application/json")) {
            const w = await y.json();
            r?.(w);
            return;
          }
          const x = y.body.getReader(), P = new TextDecoder();
          let L = "";
          for (; ; ) {
            const { done: w, value: D } = await x.read();
            if (w) break;
            L += P.decode(D, { stream: !0 });
            const $ = L.split(`
`);
            L = $.pop();
            for (const p of $)
              if (!p.startsWith("event: result") && !p.startsWith("event: error"))
                if (p.startsWith("data: ")) {
                  const S = p.slice(6);
                  try {
                    const m = JSON.parse(S);
                    m?.status || m?.uniqueId ? r?.(m) : m?.message && o?.(new Error(m.message));
                  } catch {
                    a?.(S);
                  }
                } else p.includes("STREAM_END") && a?.("Processing complete, fetching results...");
          }
        } catch (l) {
          l.name !== "AbortError" && o?.(l);
        }
      })(), i;
    }
  };
};
let I;
function O(s) {
  I = s;
}
const j = "message:timeout";
class f extends Error {
  constructor(t, n) {
    super(t), this.name = "RateLimitError", this.resetTime = n;
  }
}
async function q(s) {
  try {
    g();
  } catch (n) {
    throw new f(n.message, h()?.resetTime);
  }
  const t = await fetch(new URL("/llm/inference", "https://staging.minohealth.ai:3002").href, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(s)
  });
  if (t.status === 429) {
    let n;
    try {
      n = await t.json();
    } catch {
      n = { message: "Rate limit exceeded", resetTime: null };
    }
    throw new f(n.message, n.resetTime);
  }
  if (!t.body) throw new Error("No response body for streaming");
  return t.body.getReader();
}
export {
  f as RateLimitError,
  j as SESSION_TIMEOUT_EVENT,
  g as checkClientRateLimit,
  C as default,
  h as getRateLimitData,
  O as setApiLanguage,
  q as streamLLMInference
};
